import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { get } from 'lodash'
import { connect } from 'react-redux'
import queryString from 'query-string'

import { getToken } from 'utils/token'
import { common as commonApi } from 'redux/modules/api'
import { setImage } from 'redux/modules/images'

function decorator(config = {}) {
  return ComposedComponent => {
    @connect(
      ({ auth, images }) => ({
        user: auth.user,
        images
      }),
      { loadingImage: commonApi.loadingImage, setImage }
    )
    class DownloadImage extends PureComponent {
      static propTypes = {
        user: PropTypes.object.isRequired,
        location: PropTypes.object,
        loadingImage: PropTypes.func.isRequired,
        images: PropTypes.object.isRequired
      }

      constructor(props) {
        super(props)
        this.state = {
          downloadedImage: null
        }
      }

      componentDidMount() {
        if (__CLIENT__) {
          require('blueimp-canvas-to-blob')
        }
      }

      handleDownloadImage = imageUrl => {
        if (!imageUrl) {
          return
        }

        const { images } = this.props

        if (!imageUrl) {
          return
        }

        if (!__CLIENT__) {
          return
        }

        if (images[imageUrl]) {
          this.setState({ downloadedImage: images[imageUrl].imageLocalUrl })
          return
        }

        const xhr = new XMLHttpRequest()
        const self = this

        this.props.loadingImage(true)

        xhr.open('GET', imageUrl, true)
        xhr.setRequestHeader(
          'Authorization',
          'Bearer ' + getToken(this.props.user)
        )
        xhr.responseType = 'blob'

        self.props.setImage({
          imageUrl,
          loading: true
        })

        xhr.onload = function() {
          // eslint-disable-line
          if (this.status === 200) {
            self.setState(
              {
                downloadedImage: URL.createObjectURL(this.response)
              },
              () => {
                self.props.loadingImage(false)
                self.props.setImage({
                  imageUrl,
                  imageLocalUrl: URL.createObjectURL(this.response),
                  loading: false
                })
              }
            )
          }
        }

        xhr.send()
      }

      handleDownloadImageCode = image => {
        const operator = image.includes('?') ? '&' : '?'
        const query = queryString.parse(get(this.props, 'location.search'))
        const authCode = get(query, 'authorizationCode')

        this.setState({
          downloadedImage: `${image}${operator}authorizationCode=${authCode}`
        })
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            onDownloadImage={
              config.withCode ? (
                this.handleDownloadImageCode
              ) : (
                this.handleDownloadImage
              )
            }
            downloadedImage={this.state.downloadedImage}
          />
        )
      }
    }
    return DownloadImage
  }
}

export default decorator
